import { FC, Fragment, ReactNode, useMemo, useRef } from "react";
import MonacoEditor, { OnMount } from "@monaco-editor/react";
import AppAlert from "./../AppAlert";
import * as monaco from "monaco-editor";
import { Item, ItemProps } from ".";


interface CodeEditorProps {
    value?: string;
    onChange?: (value?: string) => void;
    height?: string | number | undefined;
    language?: string;
    label?: ReactNode;
    isError?: Boolean;
}
const CodeEditor: FC<CodeEditorProps> = ({ value, onChange, isError, label, height = 200, language = "html" }) => {
    const inputClassName = useMemo(() => {
        let className = "@app-form-code-editor w-full border rounded focus:outline-none overflow-hidden focus:border-blue-500";
        if (Boolean(isError)) {
            className += " border-red-500 focus:border-red-500 focus:ring-red-500";
        }
        return className;
    }, [isError])

    const editorRef = useRef<monaco.editor.IStandaloneCodeEditor | null>(null);
    const handleMount: OnMount = (editor, monacoInstance) => {
        editorRef.current = editor;

        // bơm type vào Monaco
        monacoInstance.languages.typescript.typescriptDefaults.addExtraLib(
            "ts:filename/formTypes.d.ts"
        );
    };

    return <div
        className="relative group/editor rounded"
        style={{ height }}
    >
        <MonacoEditor
            saveViewState
            height="100%"
            language={language}
            loading="Vui lòng chờ..."
            value={value || ""}
            onChange={(value, ev) => {
                onChange && onChange(value)
            }}
            className={inputClassName}
            options={{
                tabSize: 8,
                fontSize: 15,
                insertSpaces: false, // true = dùng space, false = dùng ký tự tab
                fixedOverflowWidgets: true, // giữ popup không bị che
                detectIndentation: false,
                renderWhitespace: "all"
            }}
            onMount={handleMount}
        />
        <button
            type="button"
            onClick={() => AppAlert.modal({
                title: label || <span>Toàn màn hình</span>,
                fullWidth: true,
                fullHeight: true,
                content: <Fragment>
                    <MonacoEditor
                        key="modal"
                        height="100%"
                        language={language}
                        loading="Vui lòng chờ..."
                        value={value || ""}
                        onChange={value => onChange && onChange(value)}
                        className={inputClassName}
                        options={{
                            tabSize: 4,
                            fontSize: 15,
                            insertSpaces: false, // true = dùng space, false = dùng ký tự tab
                            fixedOverflowWidgets: true, // giữ popup không bị che
                        }}
                    />
                </Fragment>,
            })}
            className="absolute -top-5 -right-5 bg-gray-800 text-white text-xs px-2 py-1 rounded opacity-0 group-hover/editor:opacity-80 transition"
        >
            ⛶
        </button>
    </div>
}

interface FormCodeEditor extends CodeEditorProps, ItemProps { }
export const FormCodeEditor: FC<FormCodeEditor> = ({ value, onChange, col, error, label, required, height = 200, language = "html", itemClassName, helper }) => {
    return <Item col={col} label={label} required={required} error={error} itemClassName={itemClassName} helper={helper}>
        <CodeEditor
            height={height}
            isError={Boolean(error)}
            label={label}
            language={language}
            onChange={onChange}
            value={value}
        />
    </Item>
}
export default CodeEditor;